import React, { useEffect, useState, useRef } from "react";
import { Constants } from "../../../constants/appConstants";
import { useOrderDetailsService } from "../../../services/component/orderDetailsService";
import { userService } from "../../../services/userService";
import ModalContentCenter from "../../modalContentCenter/ModalContentCenter";

interface UpdateQuantityProps {
  order: any;
  orderq: number;
  dataIndex: number;
  itemId: number;
  sequence: number;
}

const UpdateQuantityComponent: React.FC<UpdateQuantityProps> = ({ order, orderq, dataIndex, itemId, sequence }) => {
  const orderDetailsService = useOrderDetailsService();
  const [loggedInUser] = useState(userService.getCurrentUser());
  const [hidden, setHidden] = useState(true);
  const [hidePencil, setHidePencil] = useState(false);
  const [orderRefresh, setOrderRefresh] = useState(orderq);
  const [orderRefreshTemp, setOrderRefreshTemp] = useState(orderq);
  const [showQuantityWrong, setShowQuantityWrong] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setOrderRefresh(orderq);
    setOrderRefreshTemp(orderq);
    setHidden(true);
    setHidePencil(false);
    if (inputRef.current) {
      inputRef.current.value = String(orderq);
    }
  }, [itemId, order.orderId, orderq, sequence]);

  const checkQuantity = (event: React.KeyboardEvent) => {
    const regex = /^[0-9]+$/;
    const key = event.key;
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  };

  const updateQ = (value: string) => {
    const orderqnew = parseInt(value, 10);
    if (value === "" || Number.isNaN(orderqnew) || orderqnew <= 0 || orderqnew > Number(orderRefresh)) {
      refreshOrderq();
      setShowQuantityWrong(true);
      setHidden(true);
    } else {
      setHidden(true);
      setOrderRefreshTemp(orderqnew);
      order.orderLines[dataIndex].orderQuantity = orderqnew;
    }
  };

  const refreshOrderq = () => {
    setOrderRefreshTemp(orderq);
  };

  const toggle = () => {
    orderDetailsService.quantityUpdate(true);
    setHidden(!hidden);
    setHidePencil(!hidePencil);
    if (hidden) {
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.disabled = false;
          inputRef.current.focus();
          inputRef.current.select();
        }
      }, 0);
    }
  };

  const showPencil = !(
    order.status === Constants.INPROGRESS ||
    order.status === Constants.SIGNED ||
    (order.status === Constants.APPROVED && loggedInUser !== order.updatedBy) ||
    (order.orderLocked && loggedInUser !== order.updatedBy) ||
    (order.status === Constants.FAILURE && order.dtkfailed)
  );

  return (
    <div>
      <input
        ref={inputRef}
        type="number"
        name="orderQuantity"
        id="quantity"
        style={{ width: "50px", textAlign: "right" }}
        onBlur={(e) => { updateQ(e.target.value); }}
        onClick={(e) => (e.target as HTMLInputElement).select()}
        onPaste={(e) => e.preventDefault()}
        defaultValue={orderRefreshTemp}
        onKeyPress={checkQuantity}
        disabled={hidden}
      />
      {showPencil && !hidePencil && (
        <a
          className="pencil-icon"
          href="#"
          onClick={(e) => { e.preventDefault(); toggle(); }}
          style={{ color: "black" }}
        >
          <span className="glyphicon glyphicon-pencil" style={{ color: "black" }}></span>
        </a>
      )}

      <ModalContentCenter visible={showQuantityWrong}>
        <div className="modal-fade" role="dialog">
          <div className="modal-dialog modal-sm alert">
            <div className="modal-content">
              <div style={{ backgroundColor: "#e41f32", color: "white", padding: "5px" }}>
                <h4 style={{ fontSize: "12px" }}>Invalid QTY</h4>
              </div>
              <div style={{ padding: "20px", fontFamily: "Verdana", fontSize: "11px" }}>
                <p>{Constants.QUANTITY_ERROR}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default signorder"
                  style={{ backgroundColor: "#e41f32", color: "white" }}
                  onClick={() => { refreshOrderq(); setShowQuantityWrong(false); }}>OK</button>
              </div>
            </div>
          </div>
        </div>
      </ModalContentCenter>
    </div>
  );
};

export default UpdateQuantityComponent;
